import { StyleSheet, Dimensions } from 'react-native';

const { width: screenWidth } = Dimensions.get('window');

export default StyleSheet.create({
  containerStyle: {
    width: '100%',
    position: 'absolute',
    zIndex: 2
  },
  bottomStyle: theme => ({
    bottom: 0,
    zIndex: 2,
    backgroundColor: theme.colors.backgroundColorSix,
  }),
});
